import React from 'react'
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import * as cardStyles from "./StandardCard.css"
import { style } from "@vanilla-extract/css"
import ReactMarkdown from 'react-markdown'
import { theme } from "../../theme.css"
import remarkGfm from 'remark-gfm'
import { TColor, TSponsor } from "../../types"
import { colorArrayToString, determineTextColor } from "../../utils"
import { media } from "../../components/ui.css"

import {
  Text,
  Button,
} from "../ui"

export type StandardCardProps = {
  title: string
  hideCardTitle?: boolean
  displayFullWidth?: boolean
  backgroundColor: TColor
  hasButton?: boolean
  buttonText?: string
  newWindow?: boolean
  link?: string
  flushOnMobile?: boolean
  text?: string
  footnote?: string
  leftText?: boolean
  backgroundImage?: {
    id: string
    title: string
    gatsbyImageData: any
  }
  useImageForTitle?: boolean
  sponsors?: [TSponsor]
  titleImage?: {
    id: string
    title: string
    gatsbyImageData: any
  }
  sponsorshipLogoColumns?: string
  video?: any
  videoThumbnail?: {
    id: string
    title: string
    gatsbyImageData: any
  }
}



const SponsorList = ({ sponsors, displayFullWidth = false, styles = {}, sponsorshipLogoColumns = "all" }) => {
  if (sponsors.length === 0) return null;
  
  let gridStyle;
  switch (sponsorshipLogoColumns) {
    case 'all':
      gridStyle = cardStyles.sponsorsFull;
      break; 
    case 'one':
      gridStyle = cardStyles.gridOneColumn;
      break;
    case 'two':
      gridStyle = cardStyles.gridTwoColumns;
      break;
    case 'three':
      gridStyle = cardStyles.gridThreeColumns;
      break;
    case 'four':
      gridStyle = cardStyles.gridFourColumns;
      break;
    default:
      gridStyle = cardStyles.sponsorsFull; // Default to one column if undefined
  }


  return (
    <div className={cardStyles.sponsorsContainer}>
      <div className={gridStyle}>
        {sponsors.map((sponsor) => {
          const sponsorImage = getImage(sponsor.logo);
          return (
            sponsorImage ? (
              <div key={`${sponsor.id}-itm`} className={sponsor.backgroundImage ? cardStyles.sponsorItemWrapperSquare : cardStyles.sponsorItemWrapperRegular}>
                <a key={sponsor.id} href={sponsor.link} target="_blank" rel="noopener noreferrer" className={cardStyles.sponsorLogo}>
                    <GatsbyImage
                      alt={sponsor.title}
                      image={sponsorImage}
                      objectFit="contain"
                    />
                </a>
                {sponsor.backgroundImage && (
                  <div className={cardStyles.backgroundImageContainer}>
                    <GatsbyImage
                      className={cardStyles.backgroundImage}
                      alt=""
                      image={getImage(sponsor.backgroundImage)}
                    />
                  </div>
                )}
              </div>
            ) : null
          );
        })}
      </div>
      
    </div>
  );
};
/*
const _SponsorList = ({ sponsors, styles, displayFullWidth = false, sponsorshipLogoColumns = "all" }) => {
  
  if (sponsors.length === 0) return null;

  return (
    <div className={cardStyles.sponsorsContainer}>
      <div className={(displayFullWidth) ? cardStyles.sponsorsFull : cardStyles.sponsors} >
        {sponsors.map((sponsor) => {
          const sponsorImage = getImage(sponsor.logo);
          return (
            sponsorImage ? (
              <a key={sponsor.id} href={sponsor.link} target="_blank" rel="noopener noreferrer" className={cardStyles.sponsorLogo}>
                  <GatsbyImage
                    alt={sponsor.title}
                    image={sponsorImage}
                    className={cardStyles.imageStyle}
                    objectFit="contain"
                  />
              </a>
            ) : null
          );
        })}
      </div>
    </div>
  );
};
*/
export default function StandardCard(props: StandardCardProps) {
  const fontColor = determineTextColor(colorArrayToString(props.backgroundColor));
  const { sponsors, displayFullWidth, sponsorshipLogoColumns } = props;

  let style = {
      aspectRatio: "1 / 1",   // preferred shape: 1×1 square
      minWidth: "320px",          // pick whatever feels right for mobile
      minHeight: "320px",
  }
  
  if (sponsors || sponsors.length > 0) {
    style = {
      aspectRatio: "unset",   // preferred shape: 1×1 square
      minWidth: "320px",
      minHeight: '320px',
    }
  }


  return (
    <div className={cardStyles.standardCard}
      data-flush-mobile={props.flushOnMobile} data-align-left={props.leftText}
      style={{ backgroundColor: colorArrayToString(props.backgroundColor), ...style }}>
      
      <div className={cardStyles.content} style={{color: theme.colors[fontColor]}}>
        {
          /*
              { !props.hideCardTitle ? (
                !props.useImageForTitle ? (
                  <Text as="h2" variant="superHeading">{props.title}</Text>
                ) : (
                  <div className={cardStyles.titleImage}>
                    {props.link ? (
                      <a href={props.link} target={props.newWindow ? "_blank" : null }><GatsbyImage
                        alt={props.titleImage?.title}
                        image={getImage(props.titleImage)}
                      /></a>
                    ) : (
                      <GatsbyImage
                        alt={props.titleImage?.title}
                        image={getImage(props.titleImage)}
                      />
                    )}
                  </div>
                )
              ) : null }
          */
        } 
        
        { !props.hideCardTitle ? (
          //<Text as="h2" variant="superHeading">{props.title}</Text>  
          <h2 className={cardStyles.bwCardHeaderTitle} >{props.title}</h2>
        ) : null }
        {
          props.useImageForTitle ? (
              <div className={cardStyles.titleImage}>
                { props.link ? 
                  <a href={props.link} target={props.newWindow ? "_blank" : null }>
                    <GatsbyImage alt={props.titleImage?.title} image={getImage(props.titleImage)} />
                  </a>
                : 
                  <GatsbyImage alt={props.titleImage?.title} image={getImage(props.titleImage)} />
                }
              </div>
            ) : null
        }
        {props.text && (
          <div className={cardStyles.text} style={{color: theme.colors[fontColor]}}>
            <ReactMarkdown 
              remarkPlugins={[remarkGfm]}
              components={{
                h1(props) {
                  const {node, ...rest} = props
                  return <h1 className={cardStyles.cardH1MarkDown} style={{margin: 0}} {...rest} />
                },
                p(props) {
                  const {node, ...rest} = props
                  return <p className={cardStyles.cardPMarkDown} style={{margin: 0}} {...rest} />
                }
              }}
            >{props.text}</ReactMarkdown>
          </div>
        )}
        {props.hasButton && props.buttonText && (
          <Button to={props.link} variant={"homepageCard"}  target={props.newWindow ? "_blank" : null }>{props.buttonText}</Button>
        )}
        {props.footnote && (
          <div className={cardStyles.footnote} style={{color: theme.colors[fontColor]}}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{props.footnote}</ReactMarkdown>
          </div>
        )}
      </div>
      {props.backgroundImage && (
        <div className={cardStyles.backgroundImageContainer}>
          <GatsbyImage
            className={cardStyles.backgroundImage}
            alt={props.backgroundImage.title}
            image={getImage(props.backgroundImage)}
          />
        </div>
      )}
      <SponsorList 
        styles={cardStyles} 
        sponsors={sponsors} 
        displayFullWidth={displayFullWidth} 
        sponsorshipLogoColumns={sponsorshipLogoColumns} 
      />
    </div>
  )
}

export const query = graphql`
  fragment StandardCardContent on StandardCard {
    id
    desktopRight
    title
    hideCardTitle
    blocktype
    useImageForTitle
    sponsors {
      id
      title
      link
      logo {
        id
        title
        ... on DatoCmsAsset {
          gatsbyImageData(
            imgixParams: {w: "220"}
          )
        }
      }
      ... on DatoCmsSponsor {
        id
        sponsorCategories {
          categoryName
          slug
        }
      }
      backgroundImage {
      id
      title
      url
      ... on DatoCmsAsset {
        gatsbyImageData(
          #imgixParams: {crop: "focalpoint", fit: "crop", w: "1200", h: "1200"}
          imgixParams: {crop: "focalpoint", fit: "crop"},
          layout: FULL_WIDTH,
          aspectRatio: 1.77, # Default aspect ratio for desktop (16:9)
          sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 1920px",
          breakpoints: [320, 480, 768, 1024, 1280, 1920],
        )
      }
    }
    }
    sponsorshipLogoColumns
    backgroundColor {
      red
      blue
      green
      alpha
    }
    hasButton
    buttonText
    newWindow
    link
    flushOnMobile
    text
    footnote
    leftText
    backgroundImage {
      id
      title
      url
      ... on DatoCmsAsset {
        gatsbyImageData(
          #imgixParams: {crop: "focalpoint", fit: "crop", w: "1200", h: "1200"}
          imgixParams: {crop: "focalpoint", fit: "crop"},
          layout: FULL_WIDTH,
          aspectRatio: 1.77, # Default aspect ratio for desktop (16:9)
          sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 1920px",
          breakpoints: [320, 480, 768, 1024, 1280, 1920],
        )
      }
    }
    titleImage {
      id
      title
      ... on DatoCmsAsset {
        gatsbyImageData(
          imgixParams: {w: "900"}
        )
      }
    }
    video {
      id
      title
      ... on DatoCmsAsset {
        id
        video {
          mp4High: mp4Url(res: high)
          mp4Med: mp4Url(res: medium)
          mp4Low: mp4Url(res: low)
          duration
          thumbJpg: thumbnailUrl(format: jpg)
          thumbPng: thumbnailUrl(format: png)
          thumbGif: thumbnailUrl(format: gif)
        }
      }
    }
    videoThumbnail {
      id
      title
      url
      ... on DatoCmsAsset {
        gatsbyImageData(
          imgixParams: {crop: "focalpoint", fit: "crop"},
          layout: FULL_WIDTH,
          aspectRatio: 1.77, # Default aspect ratio for desktop (16:9)
          sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 1920px",
          breakpoints: [320, 480, 768, 1024, 1280, 1920],
        )
      }
    }
  }
`